export const FETCH_PRODUCT_PROPS = `FETCH_PRODUCT_PROPS`;
export const TRANSLATE_PRODUCT_PROPS = `TRANSLATE_PRODUCT_PROPS`;
export const UPDATE_SELECTED_PROPS = `UPDATE_SELECTED_PROPS`;
export const FETCH_PRODUCT_BRANDS = `FETCH_PRODUCT_BRANDS`;
export const UPDATE_SELECTED_BRANDS = `UPDATE_SELECTED_BRANDS`;
export const UPDATE_SELECTED_BRANDS_AND_PROPS = `UPDATE_SELECTED_BRANDS_AND_PROPS`;
export const TOGGLE_PROPS_SECTION = `TOGGLE_PROPS_SECTION`;
export const INIT_SELECTED_PROPS = `INIT_SELECTED_PROPS`;
export const RESET_PROPS = `RESET_PROPS`;
